import { Link, LinkButton } from "@/components/core/tanstack-link";
import { useAuth } from "@clerk/react";
import { AppBar, Box, Link as MuiLink, Toolbar } from "@mui/material";
import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import zod from "zod";

const schema = zod.object({
  redirect_url: zod.string().catch("/").optional(),
});

export const Route = createFileRoute("/_auth")({
  component: RouteComponent,
  validateSearch: schema,
});

function RouteComponent() {
  const { isLoaded, isSignedIn } = useAuth();
  const matches = useMatches();

  return (
    <Box
      sx={{
        minHeight: "100%",
      }}
    >
      <AppBar
        position="fixed"
        component="nav"
        sx={{
          boxShadow: "none",
          backgroundColor: "primary.contrastText",
          borderBottomWidth: "1px",
          borderBottomColor: "divider",
          borderBottomStyle: "solid",
          "@media print": {
            display: "none",
          },
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            color: "primary.main",
            paddingX: 2,
            paddingY: 1,
            gap: 4,
            alignItems: "center",
            width: { xs: "100%", lg: "50vw" },
          }}
        >
          {isLoaded && !isSignedIn ? (
            <>
              <MuiLink href={"https://trove.works"} sx={{ display: "flex", alignItems: "center" }}>
                <Box alt="Trove" component="img" height={28} src="/assets/logo.svg" />
              </MuiLink>
              {matches.some(
                (m) => m.loaderData && "crumb" in m.loaderData && m.loaderData?.crumb == "Sign in",
              ) && (
                <LinkButton variant="contained" sx={{ ml: "auto" }} to="/signup/$">
                  Sign up
                </LinkButton>
              )}
              {matches.some(
                (m) => m.loaderData && "crumb" in m.loaderData && m.loaderData?.crumb == "Sign up",
              ) && (
                <LinkButton variant="contained" sx={{ ml: "auto" }} to="/signin">
                  Sign in
                </LinkButton>
              )}
            </>
          ) : (
            <Link to="/" sx={{ display: "flex", alignItems: "center" }}>
              <Box alt="Trove" component="img" height={28} src="/assets/logo.svg" />
            </Link>
          )}
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          pl: { xs: "0" },
          pt: "64px",
          "@media print": {
            pl: "0",
          },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
